import initialState from './initial';
import * as types from '../constants/file';

const FileReducer = (state = initialState.documentData, action) => {
    const { type, payload } = action;
    switch (type) {
        case types.FILES_FETCH_REQUEST: {
            return { ...state, isFetching: true, error: undefined };
        }
        case 'FILE_KREDITDATA_SAVE_REQUESTED': {
            return { ...state, isFetching: true, error: undefined };
        }
        case 'FILE_KREDITDATA_SAVE_REQUEST': {
            return { ...state, isFetching: true, error: undefined };
        }
        case 'KREDITDATA_FETCH_FAIL': {
            return { ...state, isFetching: false, error: payload };
        }
        case types.FILES_FETCH_SUCCESS: {
            return { ...state, isFetching: false, ...payload };
        }
        case types.FILES_FETCH_FAIL: {
            return { ...state, isFetching: false, error: payload };
        }
        case types.FILE_UPLOAD_REQUEST: {
            return { ...state, isUploading: true, error: undefined };
        }
        case types.FILE_UPLOAD_SUCCESS: {
            return { ...state, isUploading: false, isFetching: false, documents: [...state.documents, payload.file] };
        }
        case types.FILE_UPLOAD_FAIL: {
            return { ...state, isUploading: false, error: payload };
        }
        case types.FILE_DELETE_REQUEST: {
            return { ...state, deletingId: payload.fileId, error: undefined };
        }
        case types.FILE_DELETE_SUCCESS: {
            return { ...state, deletingId: '', documents: state.documents.filter(x => x.fileId !== payload.fileId) };
        }
        case types.FILE_DELETE_FAIL: {
            return { ...state, deletingId: '', error: payload };
        }

        default:
            return state;
    }
};
export default FileReducer;
